import { FC } from 'react';
import StatusTag from './StatusTag';

interface CustomerOriginBadgeProps {
  /** customer.hubspot_contact_id — liefert die CustomerResource fuer Detail und Liste. */
  hubspotContactId?: string | null;
  /** customer.source — `iplanner` kennzeichnet Kunden aus dem iPlanner-Kundenabgleich. */
  source?: string | null;
}

/**
 * Herkunfts-Badge (Variante A, Alex 16.07.): Kunde mit hubspot_contact_id -> "HubSpot",
 * sonst "Beraterwelt". Aus dem iPlanner-Kundenabgleich angelegte Kunden (source=iplanner,
 * docs/tasks/kundenabgleich-jdc-iplanner.md) -> "iPlanner", vorrangig: ihre Herkunft
 * bleibt iPlanner, auch wenn spaeter eine HubSpot-ID dazukommt.
 * Geht bewusst ueber StatusTag — der kapselt die Farbwerte, damit hier kein Hex steht
 * (CLAUDE.md §5).
 */
const CustomerOriginBadge: FC<CustomerOriginBadgeProps> = ({ hubspotContactId, source }) => {
  if (source === 'iplanner') {
    return <StatusTag label="iPlanner" variant="teal" />;
  }

  return hubspotContactId ? (
    <StatusTag label="HubSpot" variant="orange" />
  ) : (
    <StatusTag label="Beraterwelt" variant="blue" />
  );
};

export default CustomerOriginBadge;
